export default __webpack_public_path__ + "static/media/plus-blue.af999b3e.svg";